import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTvMinimalPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.033 9.44C15.1312 9.49683 15.2127 9.57849 15.2694 9.67678C15.3261 9.77507 15.356 9.88654 15.356 10C15.356 10.1135 15.3261 10.2249 15.2694 10.3232C15.2127 10.4215 15.1312 10.5032 15.033 10.56L10.968 12.912C10.8698 12.9688 10.7584 12.9987 10.645 12.9987C10.5316 12.9987 10.4202 12.9688 10.322 12.912C10.2238 12.8552 10.1424 12.7735 10.0858 12.6752C10.0293 12.5769 9.9997 12.4654 10 12.352V7.648C9.9998 7.53473 10.0294 7.42341 10.0859 7.32523C10.1424 7.22705 10.2237 7.14548 10.3218 7.08872C10.4198 7.03195 10.531 7.002 10.6443 7.00188C10.7576 7.00175 10.8689 7.03146 10.967 7.088L15.033 9.44Z",
			stroke: "white",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 21H17",
			stroke: "white",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3Z",
			stroke: "white",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTvMinimalPlay;
